import React from 'react';
import {
  DateTime,
} from 'luxon';

import {
  Modal,
  Button,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

const getPlanStr = (plan) => {
  const interval = plan.interval === 'year' ? 'annual' : 'monthly';
  return `${plan.name} ${plan.metadata?.clients_count}, ${interval}`;
};

type Props = {
  isOpen: boolean,
  plan: any,
  periodEnd: number,
  onRequestClose: { (): void },
};

const ConfirmationModal = ({
  isOpen,
  plan,
  periodEnd,
  onRequestClose,
}: Props) => (
  <Modal
    title="Payment Confirmation"
    isOpen={isOpen}
    contentStyle={{
      marginTop: 'auto',
    }}
    onRequestClose={onRequestClose}
  >
    <Flex
      column
      width="100%"
      align="center"
      spacing={15}
    >
      <Text size="16px" align="center">
        You have selected
        {' '}
        {plan ? getPlanStr(plan) : '~'}
        ,
        and your card will be charged on
        {' '}
        {periodEnd
          ? DateTime.fromMillis(periodEnd * 1000).toFormat('MM/dd/yy')
          : '~'}
        .
        You should receive an email confirmation shortly.
      </Text>
      <Flex spacing={10}>
        <Button
          ghost
          appearance="primary"
          spacing="large"
          onClick={onRequestClose}
        >
          Ok
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default ConfirmationModal;
